import React from 'react';
import PropTypes from 'prop-types';
import { getAccessibleTextColor } from '@constants/mui-theme';
import CustomChip from '@shared/custom-chip';

const TaskStatusChip = ({ taskStatus }) => {
  if (!taskStatus) {
    return null;
  }
  return (
    <CustomChip
      colors={{
        background: taskStatus.color,
        // Status colors are arbitrary/configured server-side (e.g. "Assigned"'s gray only
        // reaches a 2.1:1 contrast ratio with white text) - pick whichever of near-black/white
        // actually contrasts best against this specific status color.
        foreground: getAccessibleTextColor(taskStatus.color)
      }}
      label={taskStatus.name}
      size="small"
    />
  );
};

TaskStatusChip.propTypes = {
  taskStatus: PropTypes.object
};

export default TaskStatusChip;
